﻿{
  "community": {
    "name": "Fællesskab",
    "shortDescription": "Enkelt konto med gratis aktiviteter",
    "features": [
      "Find og del aktiviteter",
      "Ubegrænset cloudlager til aktiviteter",
      "Adgang til premium aktiviteter"
    ],
    "price": "Gratis",
    "termName": "For livstid"
  },
  "personal": {
    "name": "Personligt abonnement",
    "shortDescription": "Enkelt konto med brugerdefinerede aktiviteter",
    "features": [
      "Opret og redigér aktiviteter online",
      "Kommer med personlig afspilningsliste",
      "Få adgang til aktiviteter på farten"
    ]
  },
  "professional": {
    "name": "Professionelt abonnement",
    "shortDescription": "Enkelt konto med flere elever",
    "features": [
      "Administration af tildelinger af opgaver til elever",
      "Overvågning af elevfremskridt",
      "Samarbejde med teammedlemmer"
    ]
  },
  "organization": {
    "name": "Organisationsabonnement",
    "shortDescription": "Flere konti med flere elever",
    "features": [
      "Underviseradministration",
      "Rapportering på organisationsniveau",
      "Indstillinger for beskyttelse af personlige data for virksomhed"
    ],
    "price": "Kontakt os",
    "termName": "Periode på 1-5 år"
  },
  "trialLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Forhåndsvisning af redigeringsprogram til pc",
    "note": "Prøv det <1>$t(common:action.free)</1> i 30 dage!",
    "price": "Gratis",
    "termName": "30 dages prøveperiode",
    "footerNote": "1 installation"
  },
  "boardmakerLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Fuldt redigeringsprogram til pc",
    "note": "",
    "termName": "Engangskøb",
    "footerNote": "2 installationer pr. bruger"
  },
  "licenseRequest": {
    "name": "Boardmaker 7",
    "shortDescription": "Flere licenser til organisationer",
    "note": "",
    "price": "Kontakt os",
    "termName": "Mængderabat",
    "footerNote": "2 installationer pr. bruger"
  }
}
